import React, { useEffect, useMemo } from 'react';
import type { PageConfig } from 'c-config';
import { PostAuthRoutes } from 'c-routes';
import {
    FilterableEntityTable,
    FilterableEntityTableRendererType,
    generateColumn,
} from 'c-pagination';
import type { CampaignReporting } from 'c-entity-types';
import { PermissionName } from 'c-sdk';
import { dashboardIcon } from 'c-main/icons';
import { FullPageEntityTableWrapper } from 'c-wrapper';
import ReactGA from 'react-ga';

const paginationTag = 'dashboard-config-list';

const columns = [
    generateColumn<CampaignReporting>({
        headerTitle: 'Modules.Admin.DashboardSetup.table.idCol',
        field: 'id',
        entityName: 'CampaignReporting',
        orderable: true,
    }),
    generateColumn<CampaignReporting>({
        headerTitle: 'Modules.Admin.DashboardSetup.table.nameCol',
        field: 'name',
        entityName: 'CampaignReporting',
        orderable: true,
    }),
];

const textSearchCols = ['name'];

// Saved dashboards only; the same table also holds summary and pca configurations.
const baseFilters = { 'filter.type': ['dashboard'] };

const DashboardSetupPage = () => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    return (
        <FullPageEntityTableWrapper title="Modules.Admin.DashboardSetup.metaTitle">
            <FilterableEntityTable
                key={paginationTag}
                tag={paginationTag}
                columns={columns}
                baseEntityName="CampaignReporting"
                routeTemplate={PostAuthRoutes.Admin.EditDashboardConfig}
                textSearchColumns={textSearchCols}
                filters={useMemo(() => baseFilters, [])}
                rendererType={FilterableEntityTableRendererType.Contained}
            />
        </FullPageEntityTableWrapper>
    );
};

const setup: PageConfig = {
    id: 'DashboardSetupPage',
    component: DashboardSetupPage,
    systemSearch: {
        title: 'Modules.Admin.DashboardSetup.metaTitle',
        description: 'Modules.Admin.DashboardSetup.description',
        type: 'page',
        icon: dashboardIcon,
        route: PostAuthRoutes.Admin.DashboardSetup,
        saveAsRecentPage: true,
        breadcrumbs: [
            { label: 'Modules.Admin.Home.metaTitle', link: PostAuthRoutes.Admin.AdminHome },
        ],
        permissions: [PermissionName.UniledportalCampaign_reportingRead],
    },
};

export default setup;
